module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"jQuery","commonjs2":"jQuery","amd":"jQuery","root":"jQuery"}
// module id = 1
// module chunks = 0